import SideArrow from "assets/svg/leftArrow.svg";
import { PreferCourseCard } from "components";
import Link from "next/link";
import React from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { Title } from "..";

function PreferCrourse({ data }: any): JSX.Element {
  function picRandomColor(index: number) {
    const colors = ["#0577AF", "#4F9B0A", "#E65800", "#77278B"];
    return colors[index % colors.length];
  }

  return (
    <div className="z-10 mb-5 flex h-auto w-full flex-col pr-[10%] md:px-[10%]">
      <div className="mb-4 flex w-full items-center justify-between md:mb-9">
        <div className="">
          <Title
            title="بسته‌های پیشنهادی"
            hideLinesOnResponsive="hidden md:flex"
          />
        </div>
        <div className="grid items-center gap-x-5 pl-[10%] text-blue md:pl-0 lg:grid-cols-3">
          <Link href={{ pathname: `/search`, query: { entityType: 1 } }}>
            <a>
              <span
                // onClick={() =>
                //     router.push(
                //         {
                //             pathname: `/search`,
                //             query: ,
                //         },
                //         undefined,
                //         { shallow: true },
                //     )
                // }
                className="cursor-pointer"
              >
                همه
              </span>
            </a>
          </Link>
          <SideArrow
            className={`swiper-button-prev-prefer-course hidden rotate-180 cursor-pointer fill-[#0577AF] lg:block`}
          />
          <SideArrow
            className={`swiper-button-next-prefer-course hidden cursor-pointer fill-[#0577AF] lg:block`}
          />
        </div>
      </div>
      <div className="relative h-auto text-white">
        <Swiper
          navigation={{
            nextEl: ".swiper-button-next-prefer-course",
            prevEl: ".swiper-button-prev-prefer-course",
          }}
          modules={[Navigation]}
          className="flex justify-center"
          breakpoints={{
            375: {
              slidesPerView: 1.1,
              spaceBetween: 5,
            },
            767: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
          }}
        >
          {data?.map(
            (
              {
                color,
                image,
                id,
                title,
                percent,
                price,
                isBuyable,
                priceWidoutDiscount,
                packageType,
                releaseDatetime,
                discount,
                teacherNames,
                seoUrlDescription,
                startDate,
              }: any,
              index: number
            ) => (
              <SwiperSlide
                key={JSON.stringify(id)}
                className="relative flex !h-auto justify-center"
              >
                <PreferCourseCard
                  {...{
                    color: picRandomColor(index),
                    image,
                    id,
                    discount,
                    title,
                    percent,
                    teacherNames,
                    price,
                    priceWidoutDiscount,
                    courseType: packageType,
                    date: releaseDatetime ?? startDate,
                    seoUrlDescription,
                    isBuyable,
                  }}
                />
              </SwiperSlide>
            )
          )}
        </Swiper>
      </div>
    </div>
  );
}

export default PreferCrourse;
